import { applyDiscountCode } from '../../../../features/discountCode/scripts';
class Accounts {
  constructor(wrapperEl) {
    if (!window.theme.customerLoggedIn) return;
    this.wrapperEl = wrapperEl;
    this.init();
  }

  async init() {
    this.wrapperEl.classList.add('loading');

    this.addLoadingSkeleton();

    await this.fetchprofile(window.theme.customerEmail);
    this.wrapperEl.classList.remove('loading');

    if (!this.customerData) {
      const smallBoxes = this.wrapperEl.querySelectorAll('.karmameju_box--small');
      smallBoxes.forEach((box) => {
        box.remove();
      });
    } else {

      this.iconCopy = window.theme.icons.copy || '';
      this.toggleWelcomeMessage();
      this.toggleBirthdayMessage();
      this.toggleKKMessage();

      this.initEventForCustomerCode();
      this.determineUserDiscountCodeStatus();

    }
  }

  initEventForCustomerCode() {
    const outerThis = this;
    const boxesWithCode = document.querySelectorAll('.karmameju_box--small');
    if (!boxesWithCode) return;
    boxesWithCode.forEach(boxWithCode => {
      boxWithCode.addEventListener('click', function () {
        if (boxWithCode.hasAttribute('is-copied')) return;
        const iconWrapper = boxWithCode.querySelector('.icon__wrapper');
        const checkMarkIcon = document.querySelector('.checkmark__wrapper .Icon.Icon--checkmark')?.cloneNode(true);
        const currentDiscountCode = boxWithCode.querySelector('#DiscountCode')
        if (!checkMarkIcon || !currentDiscountCode || !iconWrapper) return;
        outerThis.copyToClipboard(currentDiscountCode.innerText);
        const iconCheckmarkWrapper = iconWrapper.querySelector('.icon-checkmark__wrapper');
        if (!iconCheckmarkWrapper) return;
        outerThis.activateBoxWithCode(boxWithCode, iconWrapper, iconCheckmarkWrapper, checkMarkIcon)
      })
    })
  }

  activateBoxWithCode(boxWithCode, iconWrapper, iconCheckmarkWrapper, checkMarkIcon) {
    iconCheckmarkWrapper.innerHTML = '';
    iconCheckmarkWrapper.insertAdjacentHTML('beforeend', `<span>${window.languages.code_copied_to_clipboard}</span>`)
    iconCheckmarkWrapper.appendChild(checkMarkIcon);

    boxWithCode.setAttribute('is-copied', '');
    iconWrapper.querySelector('.Icon.Icon--copy')?.classList.add('d-none');

    setTimeout(() => {
      this.deactivateBoxWithCode(boxWithCode, iconWrapper, iconCheckmarkWrapper, checkMarkIcon);
    }, 10000);
  }

  deactivateBoxWithCode(boxWithCode, iconWrapper, iconCheckmarkWrapper, checkMarkIcon) {
    boxWithCode.removeAttribute('is-copied');
    iconWrapper.querySelector('.Icon.Icon--copy')?.classList.remove('d-none');
    iconCheckmarkWrapper.innerHTML = '';
  }

  copyToClipboard(copyText) {
    navigator.clipboard.writeText(copyText);
    localStorage.setItem('klub-discount-code', copyText);
    applyDiscountCode(copyText);
  }


  addLoadingSkeleton() {
    this.welcomeGiftEl = this.wrapperEl.querySelector('[data-welcome-gift]');
    if (this.welcomeGiftEl) this.welcomeGiftTextContent = this.welcomeGiftEl.querySelector('[data-text-content]');
    const welcomeGiftSkeleton = document.createElement('div');
    welcomeGiftSkeleton.classList.add('skeleton');
    this.welcomeGiftEl.appendChild(welcomeGiftSkeleton);


    this.birthdayGiftEls = this.wrapperEl.querySelectorAll('[data-birthday-gift]');
    if (this.birthdayGiftEls.length > 0) {
      this.birthdayGiftEls.forEach((birthdayGiftEl) => {
        this.birthdayGiftTextContent = birthdayGiftEl.querySelector('[data-text-content]');
        birthdayGiftEl.appendChild(welcomeGiftSkeleton.cloneNode(true));
      });
    }

    this.kkGiftEls = this.wrapperEl.querySelectorAll('[data-kk-gift]');
    this.kkGiftEls.forEach((kkGiftEl) => {
      kkGiftEl.appendChild(welcomeGiftSkeleton.cloneNode(true));
    });
  }

  async fetchprofile(email) {
    if (email) {
      const response = await fetch(`https://netlify.blacklemon.dk/.netlify/functions/getProfile?store=karmameju-klaviyo&email=${email}`);
      const data = await response.json();
      if (data.length > 0) {
        this.customerData = data[0];
      }
    }
  }

  toggleWelcomeMessage() {
    if (this.welcomeGiftTextContent) {
      const welcomeGiftRedeemed = this.customerData.attributes.properties.KK_velkomstgave_indløst;
      if (welcomeGiftRedeemed) {
        this.welcomeGiftEl.remove();
      } else {

        const welcomeGiftValue = this.welcomeGiftTextContent.dataset.textContent;
        if (welcomeGiftValue && window.languages.welcome_gift_not_redeemed) {

          this.iconClipBuilder(this.welcomeGiftEl);
          this.welcomeGiftTextContent.innerHTML = window.languages.welcome_gift_not_redeemed + '<span id="DiscountCode">' + welcomeGiftValue + '</span>';
        } else {
          this.welcomeGiftEl.remove();
        }
      }
    } else {
      this.welcomeGiftEl.remove();
    }
  }

  toggleBirthdayMessage() {
    this.birthdayGiftEls.forEach((birthdayGiftEl) => {
      const birthdayGiftTextContent = birthdayGiftEl.querySelector('[data-text-content]');
      const birthdayGiftProperty = birthdayGiftEl.dataset.birthdayGift;
      if (birthdayGiftTextContent) {
        const birthdayGiftValue = birthdayGiftTextContent.dataset.textContent;

        const birthdayGiftPropertyValue = this.customerData.attributes.properties[birthdayGiftProperty];
        if (birthdayGiftPropertyValue && window.languages.birthday_gift_not_redeemed && birthdayGiftValue) {

          this.iconClipBuilder(birthdayGiftEl);
          birthdayGiftTextContent.innerHTML = window.languages.birthday_gift_not_redeemed + '<span id="DiscountCode">' + birthdayGiftValue + '</span>';
        } else {
          birthdayGiftEl.remove();
        }
      } else {
        birthdayGiftEl.remove();
      }
    });
  }

  iconClipBuilder(currentWrapper) {
    const iconWrapper = document.createElement('div');
    const iconCheckmarkWrapper = document.createElement('div');
    iconCheckmarkWrapper.classList.add('icon-checkmark__wrapper');
    iconWrapper.classList.add('icon__wrapper');
    iconWrapper.setAttribute('copy-code-to-clipboard', '');
    iconWrapper.innerHTML = this.iconCopy;
    iconWrapper.prepend(iconCheckmarkWrapper);

    const boxGrid = currentWrapper.querySelector('.karmameju_box_grid');
    if (!boxGrid) return;
    boxGrid.appendChild(iconWrapper);

    const skeleton = currentWrapper.querySelector('.skeleton');
    if (!skeleton) return;
    skeleton.classList.add('d-none');
  }

  toggleKKMessage() {
    this.kkGiftEls.forEach((kkGiftEl) => {
      const kkGiftTextContent = kkGiftEl.querySelector('[data-text-content]');
      const kkGiftProperty = kkGiftEl.dataset.kkGift;
      if (kkGiftTextContent) {
        const kkGiftValue = kkGiftTextContent.dataset.textContent;

        const kkGiftPropertyValue = this.customerData.attributes.properties[kkGiftProperty];
        if (kkGiftPropertyValue && window.languages.kk_gift_not_redeemed && kkGiftValue) {
          this.iconClipBuilder(kkGiftEl);
          kkGiftTextContent.innerHTML = window.languages.kk_gift_not_redeemed + '<span id="DiscountCode">' + kkGiftValue + '</span>';
        } else {
          kkGiftEl.remove();
        }
      }
    });
  }

  determineUserDiscountCodeStatus() {
    const smallBoxes = this.wrapperEl.querySelectorAll('.karmameju_box--small');
    if (smallBoxes.length === 1) {
      if (!smallBoxes[0]) return;
      smallBoxes[0].classList.remove('d-none');
      document.querySelector('.karmameju_boxes__info--no-benefits').classList.remove('d-none');

    }
    else document.querySelector('.karmameju_boxes__info--with-benefits ').classList.remove('d-none');

  }
}

const kkBoxes = document.getElementById('karmameju_boxes');
if (kkBoxes) {
  new Accounts(kkBoxes);
}
